// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var TerceraChartMouseState;
(function (TerceraChartMouseState) {
    TerceraChartMouseState[TerceraChartMouseState["None"] = 0] = "None";
    TerceraChartMouseState[TerceraChartMouseState["Moving"] = 1] = "Moving";
})(TerceraChartMouseState || (TerceraChartMouseState = {}));
